import { V2LawApplicabilityDetermineSheet } from '../V2LawApplicabilityDetermineSheet'
import { V2LawApplicabilityOverrideDialog } from '../V2LawApplicabilityOverrideDialog'
import { V2LawApplicabilityQuestionnaireSheet } from '../V2LawApplicabilityQuestionnaireSheet'
import { useV2ProductRegulationSection } from './context'

export function V2ProductRegulationSectionSheets() {
  const {
    productId,
    law,
    lawLabel,
    applicability,
    questionnaireEditDisabled,
    isLawDiscoverPending,
    onRunLawDiscover,
    determineSheetOpen,
    setDetermineSheetOpen,
    questionnaireOpen,
    setQuestionnaireOpen,
    overrideDialogOpen,
    setOverrideDialogOpen,
    handleRunTest,
    handleAnswerManually,
  } = useV2ProductRegulationSection()
  const pendingOnly = applicability?.status === 'NEEDS_GRILLING'

  return (
    <>
      <V2LawApplicabilityDetermineSheet
        lawLabel={lawLabel}
        open={determineSheetOpen}
        runTestDisabled={questionnaireEditDisabled || onRunLawDiscover == null}
        isRunningTest={isLawDiscoverPending}
        onOpenChange={setDetermineSheetOpen}
        onRunTest={handleRunTest}
        onAnswerManually={handleAnswerManually}
      />
      <V2LawApplicabilityQuestionnaireSheet
        productId={productId}
        law={law}
        lawLabel={lawLabel}
        open={questionnaireOpen}
        disabled={questionnaireEditDisabled}
        pendingOnly={pendingOnly}
        onOpenChange={setQuestionnaireOpen}
      />
      <V2LawApplicabilityOverrideDialog
        productId={productId}
        law={law}
        lawLabel={lawLabel}
        applicability={applicability}
        open={overrideDialogOpen}
        onOpenChange={setOverrideDialogOpen}
      />
    </>
  )
}
